import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Logs from '../../../../views/NewLogs/Logs';

const NewLogsPageRoute = () => {
    return (    
        <Routes>
            <Route path="" element={<Logs />} />            
        </Routes>    
    );
};

export default NewLogsPageRoute;